import InvoicesContent from "../../../../src/pages/use-cases/page-content/financial/invoices.md";
import * as React from 'react';
export default {
  InvoicesContent,
  React
};